import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faHelmetSafety,
  faTrowelBricks,
  faWrench,
  faStamp,
  faPersonDigging,
  faCircleCheck,
  faPencil,
  faChevronDown,
  faClose,
  faStar,
  faKitchenSet,
  faBath,
  faHouseChimney,
  faStairs,
  faPaintRoller,
  faHouse,
  faMapLocationDot,
  faHouseChimneyWindow,
  faArrowRight
} from '@fortawesome/free-solid-svg-icons';

library.add(
  faHelmetSafety,
  faTrowelBricks,
  faWrench,
  faStamp,
  faPersonDigging,
  faCircleCheck,
  faPencil,
  faChevronDown,
  faClose,
  faStar,
  faKitchenSet,
  faBath,
  faHouseChimney,
  faStairs,
  faPaintRoller,
  faHouse,
  faMapLocationDot,
  faHouseChimneyWindow,
  faArrowRight
); 